import { useState } from "react";
import { Edit, Trash } from "iconsax-reactjs";
import type { StoryDetail } from "../../../services/webServices/srory/types";
import { getStoryById } from "../../../services/webServices/srory/get";

type StoryCarouselItemProps = {
  uuid: string;
  coverSrc: string;
  label: string;
  title: string;
  onEdit: (uuid: string) => void;
  onDelete: (uuid: string) => void;
};

export default function StoryCarouselItem({ coverSrc, label, title, uuid, onEdit, onDelete }: StoryCarouselItemProps) {

  const [open, setOpen] = useState(false);
  const [story, setStory] = useState<StoryDetail | null>(null);

  const isVideo = story?.content?.endsWith("webm");

  const onOpenStory = async () => {
    setOpen(true);
    const res = await getStoryById({ uuid });
    setStory(res!);
  };

  const handleDelete = async () => {
    const confirmed = window.confirm("آیا از حذف این استوری مطمئن هستید؟");
    if (!confirmed) return;

    onDelete(uuid);
  };

  return (
    <>
      {open && (
        <div
          onClick={ () =>{setOpen(false)} }
          className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white w-[420px] h-[80vh] rounded-xl shadow-xl flex items-center justify-center"
          >
            {!story && (
              <span className="text-sm text-gray-400">
                در حال بارگذاری...
              </span>
            )}
            {story &&
              (isVideo ? (
                <video
                  src={process.env.REACT_APP_File_URL! + story.content}
                  controls
                  autoPlay
                  playsInline
                  className="w-full rounded-lg"
                />
              ) : (
                <img
                  src={process.env.REACT_APP_File_URL! + story.content}
                  className="w-full rounded-lg"
                  alt=""
                />
              ))
              }
          </div>
        </div>
      )}

      <div className="flex flex-col items-center gap-4 w-28 flex-shrink-0">
        <div className="relative">
          <div
            onClick={onOpenStory}
            className="w-20 h-20 rounded-full ring-2 ring-primaryVar-600 p-1 transition-all duration-200 hover:ring-primaryVar-400 hover:scale-105 cursor-pointer"
          >
            <img
              src={process.env.REACT_APP_File_URL + coverSrc}
              alt=""
              className="w-full h-full rounded-full object-cover"
            />
          </div>
          <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-primaryVar-100 text-primaryVar-700 text-xs px-2 py-0.5 rounded-md whitespace-nowrap border-2 border-white">
            {label}
          </span>
        </div>
        <h3 className="text-sm font-medium truncate max-w-full text-gray-600">
          {title}
        </h3>
        <div className="flex gap-1">
          <div className="relative h-7 w-7">
            <span className="absolute top-0 left-0 w-2 h-2 border-t border-l border-red-100 rounded-tl-sm" />
            <span className="absolute top-0 right-0 w-2 h-2 border-t border-r border-red-100 rounded-tr-sm" />
            <span className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-red-100 rounded-bl-sm" />
            <span className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-red-100 rounded-br-sm" />
            <button
              type="button"
              title="حذف استوری"
              onClick={handleDelete}
              className="h-7 w-7 flex items-center justify-center rounded-sm hover:bg-red-50 transition-colors"
            >
              <Trash size={16} className="text-red-600" />
            </button>
          </div>
          <div className="relative h-7 w-7">
            <span className="absolute top-0 left-0 w-2 h-2 border-t border-l border-blue-100 rounded-tl-sm" />
            <span className="absolute top-0 right-0 w-2 h-2 border-t border-r border-blue-100 rounded-tr-sm" />
            <span className="absolute bottom-0 left-0 w-2 h-2 border-b border-l border-blue-100 rounded-bl-sm" />
            <span className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-blue-100 rounded-br-sm" />
            <button
              type="button"
              title="ادیت استوری"
              onClick={() => onEdit(uuid)}
              className="h-7 w-7 flex items-center justify-center rounded-sm hover:bg-blue-50 transition-colors"
            >
              <Edit size={16} className="text-blue-600" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};